<nav [class]="'w-full flex justify-between py-lg px-6xl ' + navClass()">
  <lib-navbar-banner-logo
    [isCentral]="isCentral()"
    [selectedWorkspace]="selectedWorkspace()"
    [projectName]="projectName()" />

  <div class="flex items-center gap-md">
    @if (isLoggedIn() && canUseNotifications()) {
      <lib-notification-bell placement="navbar" />
    }

    @if (isLoggedIn()) {
      <lib-profile-dropdown />
    } @else {
      <lib-lang-switcher />
    }
  </div>
</nav>
